import type { ReactNode } from "react";

import type { BadgeColors } from "./commLabels";

// communicatie (visual parity): a status/herkomst pill that paints the EXACT Jmix theme hex
// (via inline style — the "category colours = Jmix hex" parity pattern) rather than the generic
// @fawkes/ui semantic tones. The pill geometry mirrors the Jmix `.comm-status-badge` /
// `.comm-origin-badge` rule (pill radius, 600 weight, small padding) so the list/detail match
// the Jmix communicatie module 1:1. Kept local to the communicatie pages (NOT a shared component).
export function CommBadge({ colors, children }: { colors: BadgeColors; children: ReactNode }) {
  return (
    <span
      className="comm-badge"
      style={{ backgroundColor: colors.bg, color: colors.fg }}
    >
      {children}
    </span>
  );
}
